(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-banner-hero"] && !Shopify.designMode) return;
  try {
    
  const bannerInstances = new WeakMap();
  const bannerSelector = '[data-section-type="multi-banner-hero"]';

  function initBanner(section) {
    if (bannerInstances.has(section)) return;

    const layoutMode = section.dataset.layoutMode || 'grid';
    const sliderCandidate = ['slider', 'slider_mobile', 'slider_desktop'].includes(layoutMode);
    if (!sliderCandidate) return;

    const track = section.querySelector('[data-slider-track]');
    const slides = Array.from(section.querySelectorAll('[data-banner-item]'));
    const dots = Array.from(section.querySelectorAll('[data-banner-dot]'));
    const progress = section.querySelector('[data-banner-progress]');
    const progressStyle = section.dataset.progressStyle || 'pie';
    const circumference =
      progress && progressStyle === 'ring' && typeof progress.getTotalLength === 'function'
        ? progress.getTotalLength()
        : 0;
    const autoplayEnabled = section.dataset.autoplay !== 'false' && slides.length > 1;
    const delay = parseInt(section.dataset.autoplayDelay || '0', 10) || 10000;

    if (!track || slides.length <= 1) return;

    let current = 0;
    let timer = null;
    let startX = null;
    let deltaX = 0;
    let sliderActive = false;

    const desktopMedia = window.matchMedia('(min-width: 768px)');
    const controller = new AbortController();
    const listen = (target, type, handler) => {
      target.addEventListener(type, handler, { signal: controller.signal });
    };
    bannerInstances.set(section, () => {
      clearInterval(timer);
      controller.abort();
      bannerInstances.delete(section);
    });

    if (progress && circumference) {
      progress.style.strokeDasharray = `${circumference}`;
      progress.style.strokeDashoffset = `${circumference}`;
    }

    function restartProgress() {
      if (!progress || !sliderActive || !autoplayEnabled) return;
      progress.classList.remove('is-active');
      if (progressStyle === 'ring' && circumference) {
        progress.style.strokeDashoffset = `${circumference}`;
      } else {
        progress.style.setProperty('--banner-progress', '0deg');
      }
      void progress.getBoundingClientRect();
      progress.classList.add('is-active');
    }

    function shouldBeSlider() {
      if (layoutMode === 'slider') return true;
      if (layoutMode === 'slider_mobile') return !desktopMedia.matches;
      if (layoutMode === 'slider_desktop') return desktopMedia.matches;
      return false;
    }

    function setSlide(next) {
      current = (next + slides.length) % slides.length;
      track.style.setProperty('--current', current);
      dots.forEach((dot, index) => {
        const isActive = index === current;
        dot.classList.toggle('is-active', isActive);
        dot.removeAttribute('aria-current');
        if (isActive) {
          dot.classList.remove('is-active');
          void dot.offsetWidth;
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        }
      });

      restartProgress();
    }

    function startAutoplay() {
      if (!autoplayEnabled || !sliderActive) return;
      clearInterval(timer);
      timer = setInterval(() => setSlide(current + 1), delay);
      restartProgress();
    }

    function syncSliderState() {
      const desired = shouldBeSlider() && slides.length > 1;
      if (desired === sliderActive) return;
      sliderActive = desired;
      section.dataset.sliderActive = sliderActive ? 'true' : 'false';
      if (!sliderActive) {
        clearInterval(timer);
        track.style.setProperty('--current', 0);
        if (progress) {
          progress.classList.remove('is-active');
          if (progressStyle === 'ring' && circumference) {
            progress.style.strokeDashoffset = `${circumference}`;
          } else {
            progress.style.setProperty('--banner-progress', '0deg');
          }
        }
        return;
      }
      setSlide(current);
      startAutoplay();
    }

    dots.forEach((dot) => {
      listen(dot, 'click', () => {
        if (!sliderActive) return;
        const next = Number(dot.dataset.index) || 0;
        setSlide(next);
        startAutoplay();
      });
    });

    listen(track, 'pointerdown', (event) => {
      if (!sliderActive) return;
      startX = event.clientX;
      deltaX = 0;
    });

    listen(track, 'pointermove', (event) => {
      if (startX === null) return;
      deltaX = event.clientX - startX;
    });

    listen(track, 'pointerup', () => {
      if (startX === null) return;
      if (Math.abs(deltaX) > 50 && sliderActive) {
        setSlide(current + (deltaX < 0 ? 1 : -1));
        startAutoplay();
      }
      startX = null;
      deltaX = 0;
    });

    listen(track, 'pointercancel', () => {
      startX = null;
      deltaX = 0;
    });

    sliderActive = shouldBeSlider() && slides.length > 1;
    section.dataset.sliderActive = sliderActive ? 'true' : 'false';
    setSlide(0);
    if (sliderActive) startAutoplay();
    listen(desktopMedia, 'change', syncSliderState);
  }

  function forEachBanner(root, callback) {
    if (root.matches?.(bannerSelector)) callback(root);
    root.querySelectorAll(bannerSelector).forEach(callback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => forEachBanner(document, initBanner), { once: true });
  } else {
    forEachBanner(document, initBanner);
  }

  document.addEventListener('shopify:section:load', (event) => {
    forEachBanner(event.target, initBanner);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    forEachBanner(event.target, (section) => bannerInstances.get(section)?.());
  });

  } catch(e) { console.error(e); }
})();
})();
